"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Allegheny = void 0;
const helper_1 = require("../../helper");
class Allegheny {
    parse(pastedData, event, callbackEmit) {
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const nameAndAddress = (0, helper_1.substrInBetween)(pastedData, "215-638-2223\n", "ID:");
            const [name, ...address] = nameAndAddress.split("\n");
            const nameObj = {
                firstName: (0, helper_1.trim)(name.split(",")[1]),
                lastName: (0, helper_1.trim)(name.split(",")[0]),
            };
            const addressObj = { placeName: address.join(" ") };
            const idLine = (0, helper_1.substrInBetween)(pastedData, "\nID:", "ID:");
            const indexOfPhoneNumber = idLine.indexOf("Phone: ") + "Phone: ".length;
            const phoneNo = idLine.substring(indexOfPhoneNumber, idLine.length);
            const dob = (0, helper_1.getDOB)((0, helper_1.substrInBetween)(pastedData, "Birthday: ", "Age:"));
            const insuranceInfo = (0, helper_1.substrInBetween)(pastedData, "Insurance Information:\n", ":");
            const insurance = this.getInsurance(insuranceInfo);
            const caregiverRaw = (0, helper_1.substrInBetween)(pastedData, "Emergency ", "Ordered:");
            const caregiverName = (0, helper_1.substrInBetween)(caregiverRaw, "Contacts: ", ", Ph:");
            const caregiverPhoneNumber = (0, helper_1.substrInBetween)(caregiverRaw, "Ph:", "Labs");
            //we saw some weird spacing issues on pdf copy, so the code tries both these parsing strategies.
            let physicianRaw = (0, helper_1.substrInBetween)(pastedData, "Physicians, Pharmacy, A", "m a c y :");
            if (physicianRaw === "") {
                physicianRaw = (0, helper_1.substrInBetween)(pastedData, "Physicians, Pharmacy, A", "macy:");
            }
            const physicianName = (0, helper_1.substrInBetween)(physicianRaw, "mbulance:", "NPI:");
            const physicianNo = (0, helper_1.substrInBetween)(physicianRaw, "Ph: ", "Fax: ");
            const sendCallBackData = Object.assign(Object.assign({ patientInfo: Object.assign(Object.assign({}, nameObj), { address: addressObj, phoneNo, email: "", dob }) }, insurance), { info: {
                    physician: [
                        {
                            name: physicianName,
                            phoneNo: physicianNo,
                            countryCode: "+1",
                            sortOrder: 1,
                        },
                    ],
                    pharmacy: [],
                    careGiver: [
                        {
                            name: caregiverName,
                            phoneNo: caregiverPhoneNumber,
                            countryCode: "+1",
                            sortOrder: 1,
                        },
                    ],
                } });
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function getInsurance
     * @param insuranceInfo
     * @summary Getting Insurance from kinnserHospice
     */
    getInsurance(insuranceInfo) {
        return { insurance: (0, helper_1.trim)(insuranceInfo) };
    }
}
exports.Allegheny = Allegheny;
